/**
 * SOIREVE Header JS
 * - ãç¥ãããã¼ éãã
 * - æ¤ç´¢ãã¼ ãã°ã«
 * - ã¢ãã¤ã«ãã­ã¯ã¼ã¡ãã¥ã¼
 * - ã¹ã¯ã­ã¼ã«æãããã¼å½±
 * - Predictive Searchï¼Shopify APIï¼
 */

(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  /* ââ ãç¥ãããã¼ ââ */
  const announcementClose = $('#soirAnnouncementBar .soir-announcement__close');
  if (announcementClose) {
    announcementClose.addEventListener('click', () => {
      const bar = $('#soirAnnouncementBar');
      if (bar) {
        bar.style.maxHeight = bar.offsetHeight + 'px';
        requestAnimationFrame(() => {
          bar.style.transition = 'max-height .3s ease, opacity .3s ease';
          bar.style.maxHeight = '0';
          bar.style.opacity = '0';
          bar.style.overflow = 'hidden';
        });
      }
    });
  }

  /* ââ ã¹ã¯ã­ã¼ã«å½± ââ */
  const header = $('#soirHeader');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ââ æ¤ç´¢ãã¼ ââ */
  const searchToggle = $('#soirSearchToggle');
  const searchClose  = $('#soirSearchClose');
  const searchBar    = $('#soirSearchBar');

  function openSearch() {
    if (!searchBar) return;
    searchBar.classList.add('is-open');
    searchBar.setAttribute('aria-hidden', 'false');
    const input = searchBar.querySelector('input');
    if (input) setTimeout(() => input.focus(), 50);
  }
  function closeSearch() {
    if (!searchBar) return;
    searchBar.classList.remove('is-open');
    searchBar.setAttribute('aria-hidden', 'true');
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose)  searchClose.addEventListener('click',  closeSearch);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeSearch();
  });

  /* Predictive Search */
  const searchInput = searchBar ? searchBar.querySelector('input') : null;
  const suggestions = $('#soirSearchSuggestions');
  let searchTimer;

  if (searchInput && suggestions) {
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      if (q.length < 2) { suggestions.innerHTML = ''; return; }
      searchTimer = setTimeout(async () => {
        try {
          const res = await fetch(
            `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`
          );
          const data = await res.json();
          const products = data?.resources?.results?.products || [];
          if (!products.length) { suggestions.innerHTML = ''; return; }
          suggestions.innerHTML = products.map(p => `
            <a href="${p.url}" style="display:flex;align-items:center;gap:12px;padding:8px 0;border-bottom:1px solid #f0ede8;text-decoration:none;color:#1a1a1a;">
              <img src="${p.image}" alt="" style="width:44px;height:44px;object-fit:cover;border-radius:2px;">
              <span style="font-size:13px;">${p.title}</span>
            </a>
          `).join('');
        } catch (e) { /* silent */ }
      }, 250);
    });
  }

  /* ââ ã¢ãã¤ã«ã¡ãã¥ã¼ ââ */
  const burger      = $('.soir-header__burger');
  const mobileMenu  = $('#soirMobileMenu');
  const mobileClose = $('#soirMobileClose');
  const overlay     = $('#soirOverlay');

  function openMobile() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    if (burger) burger.setAttribute('aria-expanded', 'true');
  }
  function closeMobile() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    overlay && overlay.classList.remove('is-active');
    document.body.style.overflow = '';
    if (burger) burger.setAttribute('aria-expanded', 'false');
  }

  if (burger)      burger.addEventListener('click', openMobile);
  if (mobileClose) mobileClose.addEventListener('click', closeMobile);
  if (overlay)     overlay.addEventListener('click', closeMobile);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMobile(); });

  /* ãµãã¡ãã¥ã¼ ã¢ã³ã¼ãã£ãªã³ */
  $$('.soir-mobile-menu__toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.soir-mobile-menu__item');
      if (!item) return;
      item.classList.toggle('is-open');
    });
  });

  /* ââ ã«ã¼ãã«ã¦ã³ãåçæ´æ° ââ */
  const cartCount = $('#soirCartCount');
  if (cartCount) {
    document.addEventListener('cart:updated', e => {
      const count = e.detail?.cart?.item_count ?? 0;
      cartCount.textContent = count > 0 ? count : '';
    });
  }

})();
